import React from 'react';
import ProjectStyle from './ProjectStyle';
import LightSpeed from 'react-reveal/LightSpeed';

import credsee from '../../img/credsee.png';
import softwareWest from '../../img/softwareWest.png';
import bundlen from '../../img/bundlen.svg';
import zoomin from '../../img/zoomin.svg';

const Projects = () => {
    return (
        <div className="project">
           <div className="container">
               <div className="row mb-5">
                   <div className="text-center col-lg-12">
                       <p className="projectHead">My Latest Cases</p>
                   </div>
               </div>
                <div className="projectWrap pt-4">
                    <div className="row mb-5">
                        <LightSpeed right>
                            <div className="col-lg-5 offset-lg-7">
                                <a target="_blank" href="https://credsee.com">
                                    <div className="card p-2">
                                        <img className="img-fluid" src={credsee} alt="project"/>
                                        <p className="ProjectName">credsee</p>
                                        <p className="ProjectDesc">Credsee is created to help businesses and individuals measure and improve their credit with free tools and information, including credit scores, monitoring, and more.</p>
                                    </div>
                                </a>
                            </div>
                        </LightSpeed>
                    </div>
                    <div className="row mb-5">
                        <LightSpeed left>
                            <div className="col-lg-5">
                                <a target="_blank" href="https://softwarewest.com/">
                                    <div className="card p-2">
                                        <img className="img-fluid" src={softwareWest} alt="project"/>
                                        <p className="ProjectName">software West</p>
                                        <p className="ProjectDesc">Powering your Calls with Salesforce.</p>
                                    </div>
                                </a>
                            </div>
                        </LightSpeed>
                    </div>
                    <div className="row mb-5">
                        <LightSpeed right>
                            <div className="col-lg-5 offset-lg-7">
                                <a target="_blank" href="https://zoomin.com/">
                                    <div className="card p-2">
                                        <img className="img-fluid" src={zoomin} alt="project"/>
                                        <p className="ProjectName">zoomin</p>
                                        <p className="ProjectDesc">Zoomin is created with a vision of helping you craft your story in photos, with a lot of love and determination..</p>
                                    </div>
                                </a>
                            </div>
                        </LightSpeed>
                    </div>
                    <div className="row mb-5">
                        <LightSpeed left>
                            <div className="col-lg-5">
                                <a target="_blank" href="https://bundlen.com/">
                                    <div className="card p-2">
                                        <img className="img-fluid" src={bundlen} alt="project"/>
                                        <p className="ProjectName">bundlen</p>
                                        <p className="ProjectDesc">BundleN build applications with well known framework stacks along with test automation strategies and agile processes.</p>
                                    </div>
                                </a>
                            </div>
                        </LightSpeed>
                    </div>
                </div>
           </div>
            <ProjectStyle/>
        </div>
    );
};

export default Projects;
